// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlatformWebhooks_DeliveriesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /platform-webhooks/deliveries[?subscription_id=] */
import type { PlatformWebhooks_DeliveryRow } from './PlatformWebhooks_DeliveryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface PlatformWebhooks_DeliveriesResponseDados {
rows: PlatformWebhooks_DeliveryRow[]
}

export type PlatformWebhooks_DeliveriesResponse = ApiResponse<PlatformWebhooks_DeliveriesResponseDados>;

registerResponseContract('PlatformWebhooks_DeliveriesResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:              { type: 'number',  required: true },
      delivery_uuid:   { type: 'string',  required: false },
      event:           { type: 'string',  required: false },
      franquia_id:     { type: 'number',  required: false },
      is_test:         { type: 'boolean', required: false },
      plugin:          { type: 'string',  required: false },
      url:             { type: 'string',  required: false },
      status:          { type: 'string',  required: false },
      attempts:        { type: 'number',  required: false },
      response_code:   { type: 'number',  required: false },
      response_body:   { type: 'string',  required: false },
      next_attempt_at: { type: 'string',  required: false },
      delivered_at:    { type: 'string',  required: false },
      created_at:      { type: 'string',  required: false },
    },
  },
})
